const baseUrl = "https://erp-elsalab.odoo.com";

export async function loginRequest(username, password) {
  const url = `${baseUrl}/api/cs/login?login=${encodeURIComponent(
    username
  )}&password=${encodeURIComponent(password)}`;
  const res = await fetch(url, { method: "GET" });
  if (!res.ok) {
    let message = "";
    try {
      const j = await res.json();
      message = j?.message || j?.error || j?.detail || "";
    } catch (_) {
      message = await res.text().catch(() => "");
    }
    throw new Error(message || `Login failed with status ${res.status}`);
  }
  return await res.json();
}

export async function signupRequest(email, password, userName, phone) {
  const url = `${baseUrl}/api/cs/signup`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({
        login: email,
        name: userName,
        password: password,
        phone: phone,
      }),
    });

    console.log({
      login: email,
      name: userName,
      password: password,
      phone: phone,
    });

    if (!res.ok) {
      let message = "";
      try {
        const j = await res.json();
        message = j?.message || j?.error || j?.detail || "";
      } catch (_) {
        message = await res.text().catch(() => "");
      }
      throw new Error(message || `Signup failed with status ${res.status}`);
    }
    return await res.json();
  } catch (e) {
    // Handle CORS/network errors
    const msg = e?.message?.toLowerCase().includes("failed to fetch")
      ? "Network error or CORS blocked while signing up"
      : e?.message || "Signup failed";
    throw new Error(msg);
  }
}

export async function resetPasswordRequest(email) {
  const url = `${baseUrl}/api/cs/reset-password`;
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    body: JSON.stringify({ login: email }),
  });
  if (!res.ok) {
    let message = "";
    try {
      const j = await res.json();
      message = j?.message || j?.error || j?.detail || "";
    } catch (_) {
      message = await res.text().catch(() => "");
    }
    throw new Error(message || `Reset failed with status ${res.status}`);
  }
  return await res.json();
}
